<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                    <h1 class="h3 mb-0 text-gray-800">Relationships <i [popover]="esr" class="fas fa-question-circle pointer"></i></h1>
                    <popover-content #esr
                                     title="Relationships"
                                     placement="right"
                                     [animation]="true"
                                     [closeOnClickOutside]="true">
                        <p>Relationships</p>
                    </popover-content>
                    <div *ngIf="!isStandard" class="btns-container">
                        <a (click)="openModal('New', 0, ''  )" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                            <i class="fas fa-plus text-white-50"> <span class="button-text">Create Relationship</span></i>
                        </a>
                    </div>
                </div>

                <div class="card shadow">
                    <div class="">
                        <ul class="tab-nav">
                            <li (click)="currentTab(1)" class="active"><a data-toggle="tab" href="#Tab1">Custom relationships</a></li>
                            <li (click)="currentTab(2)"><a data-toggle="tab" href="#Tab2">Standard relationships</a></li>
                        </ul>
                    </div>

                    <div class="main-tab-content tab-content">
                        <div id="Tab1" class="tab-pane fade in active">
                            <div class="container-fluid">
                                <div style="width: 100%; max-height: 400px; height:400px;">
                                    <ag-grid-angular #agGrid
                                                     style="width: 100%; height: 100%;"
                                                     class="ag-theme-balham"
                                                     [enableFilter]="true"
                                                     [floatingFilter]="true"
                                                     [gridOptions]="gridOptions"
                                                     [rowData]="data"
                                                     [columnDefs]="dataHeaders"
                                                     [enableSorting]="true"
                                                     [enableColResize]="true"
                                                     (rowClicked)="onRowClicked($event)"
                                                     (gridReady)="onGridReady($event)"
                                                     [pagination]="true"
                                                     [paginationPageSize]="25"
                                                     [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                     [rowSelection]="rowSelection"
                                                     (rowSelected)="onRowSelected($event)"
                                                     (selectionChanged)="onSelectionChanged($event)"
                                                     [rowMultiSelectWithClick]="true"
                                                     [suppressRowClickSelection]="true">
                                    </ag-grid-angular>
                                </div>

                            </div>
                        </div>

                        <div id="Tab2" class="tab-pane fade">
                            <div class="container-fluid">
                                <div style="width: 100%; max-height: 400px; height:400px;">
                                    <ag-grid-angular #agGrid
                                                     style="width: 100%; height: 100%;"
                                                     class="ag-theme-balham"
                                                     [enableFilter]="true"
                                                     [floatingFilter]="true"
                                                     [gridOptions]="gridOptions"
                                                     [rowData]="standardData"
                                                     [columnDefs]="dataHeaders"
                                                     [enableSorting]="true"
                                                     [enableColResize]="true"
                                                     (rowClicked)="onStandardRowClicked($event)"
                                                     (gridReady)="onStandardGridReady($event)"
                                                     [pagination]="true"
                                                     [paginationPageSize]="25"
                                                     [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                     [rowSelection]="rowSelection"
                                                     (rowSelected)="onRowSelected($event)"
                                                     (selectionChanged)="onSelectionChanged($event)"
                                                     [rowMultiSelectWithClick]="true"
                                                     [suppressRowClickSelection]="true">
                                    </ag-grid-angular>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--NEW RATER MODAL-->
<div id="createEditModalAdmin" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">{{action}} Relationship</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">

                <div class="row" style="margin-bottom: 10px; margin-top: -5px;">
                    <div class="align-items-center justify-content-between d-sm-flex align-items-center justify-content-between mb-4">
                        <div>
                            <a></a>
                        </div>
                        <div>
                            <!--<button (click)="closeModal()" type="button" class="btn btn-secondary">Cancel</button>-->
                            <a *ngIf="action == 'Edit'" (click)="openConfirmationModal()" style="margin-left: 25px;" class="d-none d-sm-inline-block btn btn-sm btn-red shadow-sm margin-right-5">
                                <i class="fas fa-trash text-white-50"> <span class="button-text">Delete</span></i>
                            </a>
                            <a (click)="saveRater()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm   ">
                                <i class="fas fa-save text-white-50"> <span class="button-text">Save</span></i>
                            </a>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-12 col-md-2">
                        <label>Name:</label>
                    </div>
                    <div class="col-xs-12 col-md-10" style="padding: 0;">
                        <input #ratertName
                               id="raterName"
                               (keypress)="preventSpace(ratertName.value, $event, 'raterName')"
                               [(ngModel)]="name"
                               placeholder="Name"
                               type="text"
                               name="name"
                               value="" />
                    </div>
                </div>
                <!--<div class="row">
                    <div class="col-xs-12 col-md-2">
                        <label>Min:</label>
                    </div>
                    <div class="col-xs-12 col-md-10" style="padding: 0;">
                        <input #ratertMin
                               id="raterMin"
                               (keypress)="preventSpace(ratertName.value, $event, 'Min')"
                               [(ngModel)]="min"
                               min="0"
                               type="number"
                               name="min"
                               value="" />
                    </div>
                </div>-->

            </div>

            <div class="modal-footer">
                <div class="row">
                    <div class="col-md-12">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



<!--/*CONFIRMATION DELETE MODAL*/-->
<div id="confirmationDeleteModalAdmin" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Delete Relationship</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <p>Are you sure you want to delete this <b>Relationship</b>?</p>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div class="col-md-12">
                        <button data-dismiss="modal" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="deleteRaterType()" type="button" class="btn btn-primary">Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

